
import React, { useState } from 'react';
import { Input } from "@/components/ui/input";
import { Search, Filter } from 'lucide-react';
import ArticleTable from './shared/ArticleTable';
import { Article } from '@/hooks/journalist/types';

interface AllArticlesTabProps {
  articles: Article[];
}

const AllArticlesTab: React.FC<AllArticlesTabProps> = ({ articles }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [activeFilter, setActiveFilter] = useState("All");
  
  const uniqueCategories = ["All", ...new Set(articles.map(article => article.category))];
  
  const filteredArticles = activeFilter === "All" 
    ? articles 
    : articles.filter(article => article.category === activeFilter);
  
  const searchedArticles = filteredArticles.filter(article => 
    article.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
    article.excerpt.toLowerCase().includes(searchQuery.toLowerCase())
  );
  
  return (
    <>
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
        <h2 className="text-2xl font-bold">All Articles</h2>
        
        <div className="flex flex-col md:flex-row gap-4 w-full md:w-auto">
          <div className="relative w-full md:w-64">
            <Search className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
            <Input
              placeholder="Search articles..."
              className="pl-10"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          
          <div className="relative w-full md:w-48">
            <Filter className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
            <select
              className="w-full h-10 pl-10 pr-4 rounded-md border border-input bg-background"
              value={activeFilter}
              onChange={(e) => setActiveFilter(e.target.value)}
            >
              {uniqueCategories.map(category => (
                <option key={category} value={category}>{category}</option>
              ))}
            </select>
          </div>
        </div>
      </div>
      
      <div className="rounded-lg border overflow-hidden">
        <ArticleTable 
          articles={searchedArticles}
          emptyMessage="No articles found matching your criteria."
        />
      </div>
    </>
  );
};

export default AllArticlesTab;
